import {initPreview} from "./WebPreview.ts";
import {changeByVar, initTabs} from "./TabNavigation.js";
import CrmTable from "../vue/table/CrmTable.vue";
import FileZone from "../vue/file/FileZone.vue";
import FormCampaignParty from "../vue/form/FormCampaignParty.js";
import FormConsent from "../vue/form/FormConsent.js";
import FormRegion from "../vue/form/FormRegion.vue";
import FormProductBarcode from "../vue/form/FormProductBarcode.js";
import CommentsSubview from "../pages/subview/CommentsSubview.vue";
import {mountApp} from "../index.ts";


/**
 * Initialize tab navigations of subview blocks.
 * !! Call to this function is generated by SubView.java
 * @param {string} container - container name (right, bottom)
 * @param {number} blockIdx - index of block in given container (0-based)
 */
export function initSubviewTabs(container, blockIdx) {
	const links = $("#subview-tabs-"+container+"-"+blockIdx+" > a.tab");
	if (links.length > 0) {
		links.on("click", function() {
			activateTab(container, blockIdx, links, $(this));
			const viewName = $(this).attr("data-view");
			sessionStorage.setItem(viewName + "_" + container + "_" + blockIdx, $(this).attr("data-subview"));
			return false;
		});
	}
	activateBlock(container, blockIdx, links);
}

function activateBlock(container, blockIdx, links) {
	const blockTabs = $("#subview-tabs-"+container+"-"+blockIdx);
	const viewName = blockTabs.attr("data-view");
	const active = sessionStorage.getItem(viewName + "_" + container + "_" + blockIdx);
	let lnk = null;
	if (active) {
		lnk = links.filter("[data-subview=\""+active+"\"]");
	}
	if (lnk == null || lnk.length === 0) lnk = links.first();
	activateTab(container, blockIdx, links, lnk);
	initTabs(blockTabs);
}

function activateTab(container, blockIdx, links, linkToActivate) {
	let activeTabs = links.filter(function() {
		return $(this).hasClass("tab-active");
	});
	const currentTabName = activeTabs.attr("data-subview");
	links.removeClass("tab-active");
	links.each(function() { changeByVar($(this), "--link-fg")});
	$('#svb-'+currentTabName).hide();	// body

	linkToActivate.addClass("tab-active").removeClass("tab-collapsed");
	const id = linkToActivate.attr("data-subview");
	let contentDiv = $('#svb-'+id);
	changeByVar(linkToActivate, "--link-fg");
	contentDiv.show();
	loadSubviewContent(linkToActivate, contentDiv, container, blockIdx, id);
}

function loadSubviewContent(tabLink, contentDiv, container, blockIdx, id) {
	const href = tabLink.attr("href");
	if (href === "#") return;	// static content
	loadSubviewContentHref(href, contentDiv, container, blockIdx, id, false);
}

function loadSubviewContentHref(href, contentDiv, container, blockIdx, id, forceReload) {
	const loadedTimestamp = contentDiv.attr("data-loaded");
	const reallyLoad = forceReload || isTooOld(loadedTimestamp);
	if (reallyLoad) {
		jQuery.ajax(href).done((html) => {
			contentDiv.attr("data-loaded", new Date().getTime().toString());
			contentDiv.empty();
			contentDiv.html(html);
			initPreview(contentDiv);
			const fn = window["onLoad_"+id];
			if (typeof fn === 'function') {
				const pidx = href.indexOf('?');
				let params;
				if (pidx < 0) params = "";
				else params = href.substring(pidx + 1);
				fn(contentDiv, container, blockIdx, id, params);
			}
		});
	}
}

const MAX_AGE = 60000; // minute

function isTooOld(timestampAttr) {
	if (timestampAttr == null) return true;
	const ts = parseInt(timestampAttr);
	return (new Date().getTime() - ts) > MAX_AGE;
}

let attSelectHider = null;

window.onLoad_files = function(contentDiv, container, blockIdx, id, params) {

	const crmObject = Vue.createApp({
		components: {
			CrmTable
		},
		methods: {
			refresh() {
				this.$refs.subview.refresh();
			}
		}
	}).mount('#filesSubview');
		
	mountApp({
		components: {
			FileZone
		},
		methods: {
			uploaded() {
				crmObject.refresh();
			}
		}
	},'fileZoneSubview');
};

window.onLoad_worksheets = function(contentDiv, container, blockIdx, id, params) {
	Vue.createApp({
		components: {
			CrmTable
		}
	}).mount('#worksheetsSubview');
};

window.onLoad_changeLogs = function(contentDiv, container, blockIdx, id, params) {
	Vue.createApp({
		components: {
			CrmTable
		}
	}).mount('#changeLogsSubview');
};

window.onLoad_offers = function(contentDiv, container, blockIdx, id, params) {
	Vue.createApp({
		components: {
			CrmTable
		}
	}).mount('#offersSubview');
};

window.onLoad_opportunities = function(contentDiv, container, blockIdx, id, params) {
	Vue.createApp({
		components: {
			CrmTable
		}
	}).mount('#opportunitiesSubview');
};

window.onLoad_buscases = function(contentDiv, container, blockIdx, id, params) {
	Vue.createApp({
		components: {
			CrmTable
		}
	}).mount('#buscasesSubview');
};

window.onLoad_invoices = function(contentDiv, container, blockIdx, id, params) {
	Vue.createApp({
		components: {
			CrmTable
		}
	}).mount('#invoicesSubview');
};

window.onLoad_activities = function(contentDiv, container, blockIdx, id, params) {
	Vue.createApp({
		components: {
			CrmTable
		}
	}).mount('#activitiesSubview');
};

window.onLoad_consents = function(contentDiv, container, blockIdx, id, params) {
	Vue.createApp({
		components: {
			CrmTable,
			FormConsent
		}
	}).mount('#consentsSubview');
};

window.onLoad_problems = function(contentDiv, container, blockIdx, id, params) {
	Vue.createApp({
		components: {
			CrmTable
		}
	}).mount('#problemsSubview');
};

window.onLoad_problemwatchmen = function(contentDiv, container, blockIdx, id, params) {
	Vue.createApp({
		components: {
			CrmTable
		}
	}).mount('#problemWatchmenSubview');
};

window.onLoad_campaigns = function(contentDiv, container, blockIdx, id, params) {
	Vue.createApp({
		components: {
			CrmTable,
			FormCampaignParty
		}
	}).mount('#campaignsSubview');
};

window.onLoad_productbarcodes = function(contentDiv, container, blockIdx, id, params) {
	Vue.createApp({
		components: {
			CrmTable,
			FormProductBarcode
		}
	}).mount('#productBarcodesSubview');
};

window.onLoad_campaignParties = function(contentDiv, container, blockIdx, id, params) {
	Vue.createApp({
		components: {
			CrmTable
		}
	}).mount('#campaignPartiesSubview');
};

window.onLoad_regions = function(contentDiv, container, blockIdx, id, params) {
	mountApp({
		components: {
			CrmTable,
			FormRegion
		}
	},'regionsSubview');
};

window.onLoad_comments = function(contentDiv, container, blockIdx, id, params) {
	mountApp({
		components: {
			CommentsSubview
		}
	},'commentsSubview');
};

const MENU_WIDTH = 216;
const RESIZE_DELAY = 150; // delay after event is "complete" to run callback
let resizeTimeout = setTimeout(onResizeHandler, RESIZE_DELAY);
const objectContent = $(".object-content-inner");	// content of main grid cell
const rightContainers = $(".o-right");
const bottomContainers = $(".o-bottom");

function addWidthClass(container, space) {
	let cls;
	if (space < 512) cls = "o-small";
	else if (space < 1024) cls = "o-medium";
	else cls = "o-large";
	container.removeClass("o-small o-medium o-large");
	container.addClass(cls);
}

function onResizeHandler() {
	let wholeSpace = window.innerWidth - MENU_WIDTH - 8;	// menu

	let contentWidth;
	if (objectContent.length > 0) contentWidth = objectContent.outerWidth();
	else contentWidth = 512;
	let contentHeight = objectContent.outerHeight();

	const isColumns = $(".object").hasClass("object-columns");

	if (rightContainers.length > 0) addWidthClass(rightContainers, wholeSpace - contentWidth - 16);
	if (bottomContainers.length > 0) addWidthClass(bottomContainers, isColumns ? contentWidth : wholeSpace - 8);
}

window.addEventListener('resize', function() {
	if (resizeTimeout) clearTimeout(resizeTimeout);
	resizeTimeout = setTimeout(onResizeHandler, RESIZE_DELAY);
});

/**
 * Reload the whole subview with extra params
 * @param element - any element contained in current subview
 * @param extraParams
 */
export function reloadSubview(element, extraParams) {
	const id = findCurrentSubviewId(element);
	if (id) reloadSubviewById(id, extraParams);
}
window.reloadSubview = reloadSubview;

export function reloadSubviewById(id, extraParams) {
	let contentDiv = $('#svb-'+id);
	let link = $('#sv-'+id);
	let href = link.attr("href");
	if (href === "#") return;
	if (extraParams) {
		href = href + (href.indexOf("?")>=0 ? "&" : "?") + extraParams;
	}
	loadSubviewContentHref(href, contentDiv, link.attr("data-container"), parseInt(link.attr("data-block")), id, true);
}
window.reloadSubviewById = reloadSubviewById;

function findCurrentSubviewId(element) {
	do {
		if (element.hasClass("subview-body")) {
			let id = element.attr("id");
			if (id.startsWith("svb-")) {
				return id.substring(4);	// strip prefix
			}
		}
	} while ((element = element.parent()).length > 0);
	return null;
}
